
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class MaterialOutBOMGrid extends Serenity.EntityGrid<MaterialOutBOMRow, any> {
        protected getColumnsKey() { return 'Sales.MaterialOutBOM'; }
        protected getDialogType() { return MaterialOutBOMDialog; }
        protected getIdProperty() { return MaterialOutBOMRow.idProperty; }
        protected getInsertPermission() { return MaterialOutBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialOutBOMRow.localTextPrefix; }
        protected getService() { return MaterialOutBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}